/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import {
  FETCH_COGNITO_USERS_REQUEST,
  FETCH_COGNITO_USERS_SUCCESS,
  FETCH_COGNITO_USERS_FAILURE,
} from './CognitoUsersTypes';

const initialState = {
  users: [],
  loading: false,
  error: null,
};

const cognitoUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COGNITO_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_COGNITO_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
        error: null,
      };
    case FETCH_COGNITO_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default cognitoUsersReducer;
